<template>
    <div class="order-detail-v1 order-detail-v1--live dlm-admin-theme" data-testid="order-detail-panel">
        <div
            v-if="isPreview"
            class="alert alert-warning order-detail-v1__banner"
            role="status"
        >
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
            {{ order.ui.labels.previewBanner }}
        </div>

        <order-detail-v1-header :order="order" />

        <div class="order-detail-v1__layout">
            <div class="order-detail-v1__main">
                <order-detail-v1-summary :order="order" />

                <order-detail-v1-return-request v-if="hasReturnRequest" :order="order" />

                <order-detail-v1-payment v-if="hasPayment" :order="order" />

                <div class="row order-detail-v1__address-row">
                    <div class="col-md-6">
                        <order-detail-v1-address
                            data-testid="order-detail-billing"
                            :title="order.ui.labels.billing"
                            :address="order.billingAddress"
                            :fiscal-title="order.ui.labels.fiscal"
                        />
                    </div>
                    <div class="col-md-6">
                        <order-detail-v1-address
                            data-testid="order-detail-shipping-address"
                            :title="order.ui.labels.shipping"
                            :address="order.shippingAddress"
                        />
                    </div>
                </div>

                <order-detail-v1-lines :order="order" />

                <order-detail-v1-timeline :order="order" />
            </div>

            <aside class="order-detail-v1__rail" data-testid="order-detail-rail" aria-label="Dettagli operativi">
                <order-detail-v1-saga-hops :order="order" />

                <order-detail-v1-shipment v-if="hasShipment" :order="order" />

                <order-detail-v1-returns v-if="hasReturns" :order="order" />

                <order-detail-v1-beestore :order="order" />

                <order-detail-v1-staged-order v-if="hasStagedOrder" :order="order" />
            </aside>
        </div>
    </div>
</template>

<script>
import mockOrderDetail from './orderDetailViewModel.mock.js';
import OrderDetailV1Header from './OrderDetailHeader.vue';
import OrderDetailV1Summary from './OrderSummaryCard.vue';
import OrderDetailV1ReturnRequest from './OrderReturnRequestCard.vue';
import OrderDetailV1Payment from './OrderPaymentCard.vue';
import OrderDetailV1Address from './OrderAddressCard.vue';
import OrderDetailV1Lines from './OrderLinesTable.vue';
import OrderDetailV1Timeline from './OrderTimeline.vue';
import OrderDetailV1SagaHops from './OrderSagaHops.vue';
import OrderDetailV1Beestore from './OrderBeeStoreCard.vue';
import OrderDetailV1Shipment from './OrderShipmentCard.vue';
import OrderDetailV1Returns from './OrderReturnsCard.vue';
import OrderDetailV1StagedOrder from './OrderStagedOrderCard.vue';

export default {
    name: 'OrderDetailPanel',
    components: {
        OrderDetailV1Header,
        OrderDetailV1Summary,
        OrderDetailV1ReturnRequest,
        OrderDetailV1Payment,
        OrderDetailV1Address,
        OrderDetailV1Lines,
        OrderDetailV1Timeline,
        OrderDetailV1SagaHops,
        OrderDetailV1Beestore,
        OrderDetailV1Shipment,
        OrderDetailV1Returns,
        OrderDetailV1StagedOrder,
    },
    props: {
        order: {
            type: Object,
            default: () => mockOrderDetail,
        },
    },
    computed: {
        isPreview() {
            return !!(this.order.ui && this.order.ui.preview);
        },
        hasReturnRequest() {
            return this.order.returnRequest != null && typeof this.order.returnRequest === 'object';
        },
        hasPayment() {
            return this.order.payment != null && typeof this.order.payment === 'object';
        },
        hasShipment() {
            return this.order.shipment != null && typeof this.order.shipment === 'object';
        },
        hasStagedOrder() {
            return this.order.stagedOrder != null && typeof this.order.stagedOrder === 'object';
        },
        hasReturns() {
            const items = this.order.returns?.items;
            const cards = this.order.giftCards?.cards || [];
            const subs = this.order.giftCards?.substitutionLines || [];
            return (Array.isArray(items) && items.length > 0) || cards.length > 0 || subs.length > 0;
        },
    },
};
</script>
